import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretUpDown24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconCaretUpDown24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.227 8.712a.75.75 0 0 0 1.06 1.06L12 6.06l3.712 3.713a.75.75 0 1 0 1.06-1.061L12.53 4.469 12 3.94l-.53.53zm9.546 6.568a.75.75 0 0 0-1.06-1.06L12 17.932 8.288 14.22a.75.75 0 1 0-1.06 1.06l4.242 4.243.53.53.53-.53z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretUpDown24);
